// removed by extract-text-webpack-plugin
module.exports = {"profile":"_3FnN_c4dkehacxduJQGYtf _35grVg_J3M0lMvKJwKpoxZ","image":"_1QToYTl_vqhkr-AwmjwP9H _1_olABk0Q-537SFX_tUniJ","name":"_3nPNA9nS00IXB0_4ry0FvA","desc":"_1B5pU47uFgYucDesZ1V6JU"};


//////////////////
// WEBPACK FOOTER
// ./src/Profile.css
// module id = 35
// module chunks = 0